import { useId } from "react";
import { BRAND } from "@/lib/brand";

interface LogoProps {
  size?: "sm" | "md" | "lg" | "xl";
  className?: string;
}

// Four circles with large circle knockout - the commons is where they all meet
export function Logo({ size = "md", className = "" }: LogoProps) {
  const sizes = {
    sm: "w-7 h-7",
    md: "w-8 h-8",
    lg: "w-10 h-10",
    xl: "w-12 h-12",
  };

  // useId generates a stable ID that's consistent between server and client
  const maskId = useId();

  return (
    <svg
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`${sizes[size]} ${className}`}
      aria-label={`${BRAND.name} logo`}
    >
      <defs>
        <mask id={maskId}>
          <rect width="32" height="32" fill="white" />
          <circle cx="16" cy="16" r="8" fill="black" />
        </mask>
      </defs>
      <g mask={`url(#${maskId})`}>
        <circle cx="9" cy="9" r="9" fill="currentColor" />
        <circle cx="23" cy="9" r="9" fill="currentColor" />
        <circle cx="9" cy="23" r="9" fill="currentColor" />
        <circle cx="23" cy="23" r="9" fill="currentColor" />
      </g>
    </svg>
  );
}

// Export for backwards compatibility if needed
export { Logo as LogoMark };
